import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById("root"));
// const script = document.createElement("script");
// script.type = "application/javascript";
// script.src = "http://localhost:3033/tracker/generate?id=5aa51";
// document.body.appendChild(script);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
